
<div id="page-engine" data-vnode-id="page-engine" :class="pageEngineClasses">
  <header-engine :page="page" />
  <template v-for="obj in clonedVDom">
    <component
      :is="obj.node.tag"
      v-if="!isReload"
      :key="obj.key"
      :fb-node="obj.node"
      v-bind="obj.node.data.props"
    ></component>
  </template>
  <footer-engine :page="page" />
</div>
